import type { BrowserOptions } from '@sentry/react';

const TRACED_ENVIRONMENTS = ['prod', 'uat', 'pre-prod', 'staging', 'stg'];

const ENDORSEMENT_EDITOR = /^\/contracts\/[^/]+\/endorsements\/[^/]+/;
const CONTRACT_EDITOR = /^\/contracts\/[^/]+/;
const CONTRACTS_LIST = /^\/contracts\/?$/;
const OTHER_BUSINESS_ROUTES =
  /^\/(templates|blocks|clauses|tags|branding|users|create-contract|eval-configs|api-docs)(\/|$)/;

const routeRate = (name: string, op: unknown) => {
  if (ENDORSEMENT_EDITOR.test(name)) return 1;
  if (CONTRACT_EDITOR.test(name)) return op === 'pageload' ? 1 : 0.25;
  if (CONTRACTS_LIST.test(name)) return 0.3;
  if (OTHER_BUSINESS_ROUTES.test(name)) return 1;
  return 0;
};

type SamplerConfig = { environment: string | undefined; isPPL: boolean };
type TracesSampler = NonNullable<BrowserOptions['tracesSampler']>;

export const createTracesSampler =
  ({ environment, isPPL }: SamplerConfig) =>
  ({ name, attributes, inheritOrSampleWith }: Parameters<TracesSampler>[0]) => {
    if (!environment || !TRACED_ENVIRONMENTS.includes(environment)) return 0;
    return inheritOrSampleWith(isPPL ? 1 : routeRate(name, attributes?.['sentry.op']));
  };
